import { useEffect, useId, useRef, useState } from 'react';
import './TreasuryTable.css';

/** Keep the table's intrinsic width inside a labelled, keyboard-scrollable region. */
export default function TreasuryTable({ children, label, className = '', identityColumn = 1 }) {
    const viewport = useRef(null);
    const hintId = useId();
    const [overflows, setOverflows] = useState(false);

    useEffect(() => {
        const element = viewport.current;
        const measure = () => setOverflows(element.scrollWidth > element.clientWidth + 1);
        measure();
        const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
        observer?.observe(element);
        if (element.firstElementChild) observer?.observe(element.firstElementChild);
        window.addEventListener('resize', measure);
        return () => {
            observer?.disconnect();
            window.removeEventListener('resize', measure);
        };
    }, [children]);

    return (
        <div className={`treasury-table ${className}`} data-identity-column={identityColumn}>
            {overflows && <p className="treasury-table-hint" id={hintId}>Llisca per veure més columnes <span aria-hidden="true">→</span></p>}
            <div ref={viewport} className="treasury-table-viewport" role="region" aria-label={label}
                aria-describedby={overflows ? hintId : undefined} tabIndex={overflows ? 0 : undefined}>
                {children}
            </div>
        </div>
    );
}
